<template>
  <div class="goods-vip-forever-protocol">
    <app-header :title="title" />
    <div class="protocol-content" :class="{ scroll: isBuy }">
      <h1 class="title">《友邻少年无限卡用户套餐协议》</h1>
      <h2>【特别提示条款】</h2>
      <ul>
        <li>
          《友邻少年无限卡会员套餐协议》（以下简称“本协议”）为《用户协议》的补充协议，由您与北京每日友邻文化科技有限公司（以下称“本公司”）共同签订。
        </li>
        <li>
          【审慎阅读】您在购买友邻少年无限卡套餐流程中点击同意本协议之前，应当认真阅读本协议，并审慎选择接受或不接受本协议。
          <span class="underline">
            请您务必审慎阅读、充分理解各条款内容，并重点阅读与您约定免除或者限制责任的条款及其他以粗体下划线标识的重要条款。
          </span>
          本协议有助于您了解本公司为您提供的友邻少年无限卡套餐服务内容及您使用服务的权利和义务。如您对本协议条款有任何疑问，您可通过客服电话010-62565909进行咨询。
        </li>
        <li>
          【签约动作】当您按照阅读并点击同意本协议且完成全部购买程序后，即表示您已充分阅读、理解并接受本协议的全部内容。本协议自您接受之时起生效并成为您与北京每日友邻文化科技有限公司之间直接有约束力的法律文件。
        </li>
      </ul>
      <h2>第一条 服务内容</h2>
      <ul>
        <li>
          1.1
          经开启无限卡套餐服务后，若无特殊情况，友邻少年APP内所有既有及后续新增的音频、视频类课程，您皆可一直免费畅听。
        </li>
        <li>1.2 经开启无限卡套餐服务后，可免费阅读友邻少年APP内的文章等材料文件。</li>
        <li>
          1.3
          <span class="underline">
            当您同意购买本服务，即代表您知晓并同意本公司不承诺每年应更新的音视频课程数量等内容。
          </span>
        </li>
        <li>
          1.4
          <span class="underline">
            当您购买本服务，即代表您理解并同意，由于版权到期或课程调整等其他原因，本公司可能会不定期对友邻少年APP内部分课程进行调整、增减，相关课程学习使用方式的最终解释权归本公司所有。
          </span>
        </li>
      </ul>
      <h2>第二条 服务期限</h2>
      <ul>
        <li>2.1 本协议约定的服务时长自本协议生效后开始计算，无论您是否实际使用，均以自然日为计算单位。</li>
        <li>2.2 本公司将尽可能保证您获得的服务时长不低于1460个自然日（4年）。</li>
        <li>
          2.3
          若因国家法律法规、相关政策发生变更、友邻少年停止经营或出现其他不可抗力等因素影响而导致您获得的服务时长低于1460个自然日，则本公司将按照您实际未获得的服务时长（1460自然日-您已获得的服务时长）向您退还费用，计算公式如下：
        </li>
        <li>退费金额=（1460-您已获得的服务时长）/1460*实际支付金额</li>
      </ul>
      <h2>第三条 收费标准</h2>
      <ul>
        <li>3.1 无限卡套餐服务是收费服务，当您根据提示确认愿意支付相关费用后，本项服务即时生效。</li>
        <li>
          3.2
          本公司可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，并可能根据实际情况，对不同阶段充值的会员给予不同的增值服务或资费政策，具体收费标准以友邻少年在相关服务页面公示的信息为准。您同意继续操作的行为（包括但不限于点击同意、支付行为等），即视为您知悉并同意该收费标准。
        </li>
      </ul>
      <h2>第四条 退款服务</h2>
      <ul>
        <li>
          4.1
          无限卡套餐为“7天内可退款”商品，您应按照《用户协议》关于“退款服务”的约定进行退款申请，但“7天内”退款须满足如下条件：
          <br />
          • 申请退款时间在付款时间的7个自然日内；
          <br />
          • 申请退款的用户听课时长不足180分钟；
          <br />
          • 申请退款的用户不得下载超过【3】个音视频文件。
          <br />
        </li>
        <li>
          4.2 超过7个自然日后，本服务原则上不允许退费，若您同时满足以下条件的，您可自主选择有偿退订无限卡套餐服务：
          <br />
          <span class="underline">
            • 以购买当日原价收费标准购买无限卡套餐的；
            <br />
          </span>
          <span class="underline">
            • 在本服务生效后的1460个自然日（4年）内选择退费的；
            <br />
          </span>
          <span class="underline">
            • 在友邻少年APP内自主购买，并非通过第三方分销或点击他人分享链接购买的。
            <br />
          </span>
          在您同时满足上述标准的前提下，本公司将根据你退订当日已享受的服务时长（无论是否实际使用）决定向你退费的金额：
          <br />
          <table class="table">
            <tr>
              <th>序号</th>
              <th>
                服务时长
                <br />
                【X】
                <br />
                （自然日）
              </th>
              <th>退费金额</th>
            </tr>
            <tr>
              <td>1</td>
              <td class="underline">8≤X≤ 365</td>
              <td>实际支付金额*75%</td>
            </tr>
            <tr>
              <td>2</td>
              <td class="underline">366＜X≤730</td>
              <td>实际支付金额*50%</td>
            </tr>
            <tr>
              <td>3</td>
              <td class="underline">731＜X≤1095</td>
              <td>实际支付金额*25%</td>
            </tr>
            <tr>
              <td>4</td>
              <td class="underline">1096＜X≤1460</td>
              <td>实际支付金额*5%</td>
            </tr>
          </table>
        </li>

        <li>
          4.3
          <span class="underline">
            本条款约定的退款金额的计算基数系您在订阅无限卡套餐服务时所实际支付的金额，不包含优惠券、奖励金等（简称“实际支付金额”）。
          </span>
          退款金额将返回您支付时所选择的支付渠道。
        </li>
      </ul>

      <h2>第五条 服务中断或终止</h2>
      <ul>
        <li class="weight">
          如发生下列任何一种情况，本公司有权随时中断或终止向您提供本条款项下的课程服务而无需通知您：
          <br />
          （1）您提供的个人资料不真实；
          <br />
          （2）您违反本协议约定；
          <br />
          （3）您违反友邻少年《用户协议》或友邻少年APP上的任何其他条款；
          <br />
          （4）您通过其他未经友邻少年认可的渠道非法购买本无限卡套餐服务；
          <br />
          （5）您违反国家法律、法规的其他规定。
          <span class="underline">
            在发生上述情况下，友邻少年有权暂时或永久封禁您的账号。在封禁期间，无限卡套餐服务时长不停止计算，同时您无法申请退款。
          </span>
        </li>
      </ul>

      <h2>第六条 其他</h2>
      <ul>
        <li>本协议为友邻少年《用户协议》的补充协议，本协议未约定事宜，均适用《用户协议》相关约定。</li>
      </ul>
    </div>
    <!-- 选择协议购买 -->
    <div class="select-protocol-buy" v-if="isBuy">
      <div class="select-protocol">
        <span class="card-icon">
          <img
            class="icon-32"
            v-if="form.protocol === 1"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox-select.png"
            alt=""
          />
          <img
            class="icon-32"
            v-if="form.protocol === 0"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox.png"
            alt=""
          />
          <span class="link" @click="detailView('goods-vip-forever-protocol')">同意《无限卡购买协议》</span>
        </span>
        <button class="btn btn-active" @click="buyGoods">立即购买</button>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { Toast } from 'mint-ui'
const componentName = 'goods-vip-forever-protocol'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  data() {
    return {
      title: '无限卡购买协议',
      form: {
        protocol: 0
      }
    }
  },
  computed: {
    isBuy() {
      return this.$route.query.isBuy
    }
  },
  methods: {
    toggleValue(name) {
      const value = this.form[name]
      this.form[name] = value ? 0 : 1
    },
    buyGoods() {
      if (this.form.protocol === 0) {
        Toast({ message: '请阅读并勾选《无限卡购买协议》，否则无法进行购买', position: 'middle' })
      } else {
        const { goodsId } = this.$route.query
        // 跳转订单支付
        if (goodsId) {
          this.$router.push({
            path: `/confirm-order/${goodsId}`,
            query: { paytype: 'vip' }
          })
        } else {
          Toast({ message: '请联系班主任获取《无限卡购买》入口', position: 'middle' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.body-goods-vip-forever-protocol {
  #app {
    display: flex;
    .goods-vip-forever-protocol {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
<style lang="scss" scoped>
.protocol-content {
  // height: 70%;
  overflow: scroll;
}
// 选择协议
.select-protocol-buy {
  margin: 0.3rem 0.3rem;
  border-top: 1px solid #eeeeee;
  padding-top: 0.3rem;
  .select-protocol {
    .card-icon {
      margin-right: 0.15rem;
    }
    .link {
      text-decoration: underline;
      margin-left: 0.15rem;
    }
    // 图标
    .icon-32 {
      vertical-align: sub;
      width: 0.32rem;
    }
    // 购买按钮
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
      width: 100%;
      margin-top: 0.3rem;
    }
  }
}
ul {
  margin: 0.2rem 0.2rem;
}
ul li {
  list-style: none;
  line-height: 0.5rem;
  font-size: 0.3rem;
  margin: 0.3rem 0.2rem;
  &.weight,
  .weight {
    font-weight: bold;
  }
  .underline {
    text-decoration: underline;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #44546a;
  }
  table {
    width: 100%;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    padding: 2px;
  }
}
.indent {
  margin-left: 20px;
}
ul.indent {
  margin-left: 25px;
  margin-top: 0;
}
h1.title {
  text-align: center;
  margin-top: 20px;
}
h2 {
  margin: 0.48rem 0.48rem 0.3rem 0.48rem;
  font-size: 0.32rem;
}
.company {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin-top: 10px;
}
.link {
  text-decoration: none;
  color: #44546a;
}
</style>
